import { render, staticRenderFns } from "./FooterCategoriesMenu.vue?vue&type=template&id=7dac0bd4"
import script from "./FooterCategoriesMenu.vue?vue&type=script&lang=js"
export * from "./FooterCategoriesMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports